"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgDineInFilled = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M19.349 2c-1.613 0-2.87 1.168-3.731 2.576l-.013.02c-.79 1.363-1.213 3.012-1.433 4.793-.22 1.786-.184 3.77-.134 5.835.013.543.395.776.935.776h1.054v5c0 .552.485 1 1.034 1h3.94a.933.933 0 0 0 .745-.35.98.98 0 0 0 .249-.65c.005-.13 0-.5 0-.5s-.004-.305 0-.5c.011-.598 0-1.5 0-1.5V5.1c0-1.4-.88-3.1-2.646-3.1ZM4 3a1 1 0 0 0-2 0v7.112c0 2.043 1.27 3.727 3 4.473V21a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.41c1.774-.763 3-2.507 3-4.478V3a1 1 0 1 0-2 0v7.112c0 1.516-1.285 2.875-2.976 2.888h-.048C5.35 12.988 4 11.691 4 10.112V3Z", fill: color }),
        React.createElement("path", { d: "M7 2a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgDineInFilled);
//# sourceMappingURL=SvgDineInFilled.js.map